import HttpService from 'commonjs-tools/build/http-service';

class ExternalService extends HttpService {
    content(url, params) {
        return this.get('/externals?url=' + url, params)
    }
}

export default ExternalService
